import { ModalProps } from '@/types/shared'
import React from 'react'

const modals: { [key: string]: React.FC<ModalProps> } = {}

// Using require.context for Rspack/Webpack compatibility
// @ts-expect-error - Webpack/Rspack-specific API
const context = require.context('./', true, /\.(js|jsx|ts|tsx)$/)
context.keys().forEach((key: string) => {
    if (key === './index.ts') return // Skip self
    const modalName = key.replace('./', '').replace(/\.\w+$/, '')
    const module = context(key) as { default: React.FC<ModalProps> }
    if (module.default) {
        modals[modalName] = module.default
    }
})

export default modals
